import React from "react";
import { DialogContentText, Typography } from "@mui/material";
import ModalLayout from "./Layout";
import ModalLayoutHeader from "./Layout/Header";
import ModalLayoutContent from "./Layout/Content";
import ModalLayoutFooter from "./Layout/Footer";
import ModalLayoutBtn from "./Layout/Btn";
import { Save } from "react-feather";

/**
 *
 * @param {{
 *  isShown: boolean;
 *  onHide: () => void;
 *  onAction: () => void;
 *  saving: boolean;
 * }} data
 */
const TestWithoutSavingModal = ({ isShown, onHide, onAction, saving }) => {
  return (
    <ModalLayout isShown={isShown} onHide={onHide}>
      <ModalLayoutHeader onHide={onHide}>
        <Typography
          component={"span"}
          fontWeight={700}
        >
          Unsaved changes
        </Typography>
      </ModalLayoutHeader>
      <ModalLayoutContent>
        <DialogContentText
          textAlign={"center"}
          color="#6c757d"
        >
          You have unsaved changes. Do you want to save before opening the Data
          Quality Tests sidebar?
        </DialogContentText>
      </ModalLayoutContent>
      <ModalLayoutFooter>
        <ModalLayoutBtn color="secondary" onClick={onHide}>
          No, go back
        </ModalLayoutBtn>
        <ModalLayoutBtn color="success" onClick={onAction} disabled={saving}>
          <Save size={16} /> Yes, Save and Open
        </ModalLayoutBtn>
      </ModalLayoutFooter>
    </ModalLayout>
  );
};

export default TestWithoutSavingModal;
